import React from 'react';
import { useChatContext, withChatContext } from 'stream-chat-react';
import { Box } from 'shared/components/display';
import styles from './styles';
import { parseChannelDisplayTitle } from 'features/messages/util';
import { useCurrentUser } from 'shared/hooks/useCurrentUser';

const MessageChannelHeader = (props) => {
  const {
    channel: {
      data: { name },
    },
  } = props;
  const { isCreator } = useCurrentUser();
  const title = isCreator ? parseChannelDisplayTitle(name) : name;
  const { openMobileNav } = useChatContext('ChannelHeader');

  const onClickHamburger = (event) => {
    if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
      openMobileNav();
    }
  };

  return (
    <Box css={styles} className="str-chat__channel-header">
      <div
        className="str-chat__header-hamburger"
        onClick={onClickHamburger}
        onKeyDown={onClickHamburger}
        role="button"
        aria-label="aria/Menu"
        tabIndex={0}
      >
        <Box className="str-chat__header-hamburger--line"></Box>

        <Box className="str-chat__header-hamburger--line"></Box>

        <Box className="str-chat__header-hamburger--line"></Box>
      </div>
      <div className="str-chat__header-livestream-left">
        <p className="str-chat__header-livestream-left--title">{title}</p>
      </div>
    </Box>
  );
};

const ChannelHeader = withChatContext(MessageChannelHeader);

export default ChannelHeader;
